import "./style.css";

export default class LogoutButton {
  static selector = ".s-logout-button";

  constructor(block) {
    this.block = block;
    this.$button = block.querySelector(".s-button");
    this.$popup = document.body.querySelector("#s-popup-logout");
  }

  onLogoutClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.$popup.setAttribute("data-active", 1);
  }

  onReady() {
    /*
    const logoutHref = document.body
      .querySelector("#logout a")
      .getAttribute("href");

    const $popupSignoutButton = this.$button.querySelector("a");
    $popupSignoutButton.setAttribute("href", logoutHref);
    $popupSignoutButton.setAttribute("target", "_self");
    */

    this.$button.addEventListener("click", this.onLogoutClick.bind(this));
  }
}
